/*********************************************************************
 * Generated by RxDjango on 2026-07-16 10:04 (UTC)                   *
 *                                                                   *
 * Based on all ContextChannel subclasses in streaming_list.channels *
 *                                                                   *
 *                       DO NOT EDIT THIS FILE                       *
 *                                                                   *
 * To rebuild it, run:                                               *
 *                                                                   *
 *     ./manage.py makefrontend [streaming_list]                     *
 *                                                                   *
 *********************************************************************/

import { ContextChannel } from '@rxdjango/react';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class StreamingListChannel extends ContextChannel {

  protected endpoint: string = "/ws/streaming_list/";
  protected baseURL: string = SOCKET_URL;

  items: number[] = [];
  ticking: boolean = true;

  pause = async () => {
    return await this.rx.callAction('pause', []);
  };

  resume = async () => {
    return await this.rx.callAction('resume', []);
  };

  reset = async () => {
    return await this.rx.callAction('reset', []);
  };
}
